(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-home"] && !Shopify.designMode) return;
  try {
    
/* Nav, menu, cart drawer, Judge.me relocation and fade-up copied from cc-product-page.liquid; Klaviyo newsletter binding from cc-coming-soon.liquid */
(function () {
  /* In the theme editor the bundled cc-product-page script runs on every page and already binds these on .cc-page */
  if (window.Shopify && window.Shopify.designMode) return;
  var page = document.querySelector('[data-cc-home]');
  if (!page) return;

  function $(sel, scope) { return (scope || page).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || page).querySelectorAll(sel)); }

  var nav = $('#cc-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    });
  }

  var hamburger = $('#cc-hamburger'),
      menuDrawer = $('#cc-menu-drawer'),
      menuOverlay = $('#cc-menu-overlay');
  function toggleMenu() {
    if (!menuDrawer) return;
    hamburger.classList.toggle('open');
    menuDrawer.classList.toggle('open');
    menuOverlay.classList.toggle('open');
    document.body.style.overflow = menuDrawer.classList.contains('open') ? 'hidden' : '';
  }
  if (hamburger) hamburger.addEventListener('click', toggleMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', toggleMenu);
  $$('[data-cc-menu-close]').forEach(function (btn) { btn.addEventListener('click', toggleMenu); });
  if (menuDrawer) {
    var menuTouchX = null;
    menuDrawer.addEventListener('touchstart', function (e) { menuTouchX = e.touches[0].clientX; }, { passive: true });
    menuDrawer.addEventListener('touchend', function (e) {
      if (menuTouchX !== null && menuTouchX - e.changedTouches[0].clientX > 60 && menuDrawer.classList.contains('open')) toggleMenu();
      menuTouchX = null;
    });
  }
  if (menuDrawer) menuDrawer.addEventListener('click', function (e) {
    if (e.target.closest('a') && menuDrawer.classList.contains('open')) toggleMenu();
  });

  var cartToggle = $('#cc-cart-toggle'),
      cartDrawer = $('#cc-cart-drawer'),
      cartOverlay = $('#cc-cart-overlay'),
      cartClose = $('#cc-cart-close'),
      cartItems = $('#cc-cart-items'),
      cartEmpty = $('#cc-cart-empty'),
      cartFooter = $('#cc-cart-footer'),
      cartTotal = $('#cc-cart-total'),
      cartCount = $('#cc-cart-count');

  function fmtMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (cartCount) {
        cartCount.textContent = cart.item_count;
        cartCount.classList.toggle('show', cart.item_count > 0);
      }
      if (!cartItems) return;
      var confirmBanner = $('#cc-cart-confirm');
      if (cart.items.length === 0) {
        cartEmpty.style.display = '';
        cartItems.innerHTML = '';
        cartFooter.style.display = 'none';
        if (confirmBanner) confirmBanner.classList.remove('show');
        return;
      }
      if (confirmBanner) confirmBanner.classList.add('show');
      cartEmpty.style.display = 'none';
      cartFooter.style.display = '';
      cartTotal.textContent = fmtMoney(cart.total_price);
      var ccCompare = {};
      try { ccCompare = JSON.parse(document.getElementById('cc-compare-data').textContent); } catch (e) {}
      var totalSavings = 0;
      var html = cart.items.map(function (item) {
        var compareLine = 0;
        if (item.original_line_price > item.final_line_price) {
          compareLine = item.original_line_price;
        } else if (ccCompare[item.variant_id]) {
          compareLine = ccCompare[item.variant_id] * item.quantity;
        }
        var priceHtml = '';
        var itemSavingsHtml = '';
        if (compareLine > item.final_line_price) {
          totalSavings += compareLine - item.final_line_price;
          priceHtml = '<s class="cc-cart-item-compare">' + fmtMoney(compareLine) + '</s> ';
          itemSavingsHtml = '<div class="cc-cart-item-savings">Du sparst ' + fmtMoney(compareLine - item.final_line_price) + '</div>';
        }
        priceHtml += '<span class="cc-cart-item-price">' + fmtMoney(item.final_line_price) + '</span>';
        return '<div class="cc-cart-item">' +
          '<div class="cc-cart-item-img"><img src="' + esc(item.image) + '" alt=""></div>' +
          '<div class="cc-cart-item-info">' +
            '<div class="cc-cart-item-title">' + esc(item.product_title) + '</div>' +
            '<div class="cc-cart-item-variant">' + esc(item.variant_title || '') + '</div>' +
            '<div class="cc-cart-item-row">' +
              '<span class="cc-cart-item-qty">' +
                '<button class="cc-cart-qty-btn" data-key="' + esc(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Menge verringern">&minus;</button>' +
                '<span class="cc-cart-qty-value">' + item.quantity + '</span>' +
                '<button class="cc-cart-qty-btn" data-key="' + esc(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Menge erh&ouml;hen">+</button>' +
              '</span>' +
              '<span>' + priceHtml + '</span>' +
            '</div>' +
            itemSavingsHtml +
            '<button class="cc-cart-item-remove" data-key="' + esc(item.key) + '">Entfernen</button>' +
          '</div>' +
        '</div>';
      }).join('');
      var savingsRow = $('#cc-cart-savings-row');
      if (savingsRow) {
        savingsRow.style.display = totalSavings > 0 ? '' : 'none';
        if (totalSavings > 0) $('#cc-cart-savings').textContent = '-' + fmtMoney(totalSavings);
      }
      if (totalSavings > 0) {
        cartTotal.innerHTML = '<s class="cc-cart-total-compare">' + fmtMoney(cart.total_price + totalSavings) + '</s> ' + fmtMoney(cart.total_price);
      }
      cartItems.innerHTML = html;
      $$('.cc-cart-qty-btn', cartItems).forEach(function (btn) {
        btn.addEventListener('click', function () {
          btn.disabled = true;
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: btn.dataset.key, quantity: parseInt(btn.dataset.qty, 10) })
          }).then(refreshCart);
        });
      });
      $$('.cc-cart-item-remove', cartItems).forEach(function (btn) {
        btn.addEventListener('click', function () {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
          }).then(refreshCart);
        });
      });
    }).catch(function () {});
  }
  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  refreshCart();

  /* Judge.me carousel renders as its own apps section at page bottom (app blocks are rejected inside this section's schema); relocate it under the reviews heading */
  var reviewsSlot = $('#cc-reviews-slot');
  var jdgmSection = document.querySelector('.shopify-section[id*="judgeme_cards_carousel"]');
  if (reviewsSlot && jdgmSection) {
    reviewsSlot.appendChild(jdgmSection);
    var pressTpl = $('#cc-press-card-tpl');
    if (pressTpl) {
      var injectPress = function () {
        if (jdgmSection.querySelector('.cc-press-jdgm')) return;
        var items = jdgmSection.querySelectorAll('.jdgm-carousel-item:not([class*="clone"])');
        if (items.length < 2) return;
        items[1].after(pressTpl.content.firstElementChild.cloneNode(true));
      };
      injectPress();
      new MutationObserver(injectPress).observe(jdgmSection, { childList: true, subtree: true });
    }
    if (window.matchMedia('(max-width: 700px)').matches) {
      /* Judge.me's slider JS swallows touch events; capture-stop them so the native overflow scroll gets the swipe */
      ['touchstart', 'touchmove', 'touchend'].forEach(function (t) {
        reviewsSlot.addEventListener(t, function (e) { e.stopPropagation(); }, { capture: true, passive: true });
      });
    }
  }

  /* Klaviyo blocks some clients (bot protection, carrier IPs); fall back to the native Shopify form. requestSubmit keeps Shopify's CAPTCHA handler in the loop. */
  var nlForm = $('#cc-newsletter-form');
  if (nlForm) {
    var fallback = function (btn) {
      nlForm.dataset.ccFallback = '1';
      btn.disabled = false;
      if (nlForm.requestSubmit) { nlForm.requestSubmit(); } else { btn.click(); }
    };
    nlForm.addEventListener('submit', function (e) {
      if (nlForm.dataset.ccFallback) return;
      e.preventDefault();
      var emailEl = $('#cc-nl-email');
      var btn = nlForm.querySelector('button');
      var status = $('#cc-nl-status');
      btn.textContent = '...';
      btn.disabled = true;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Y8fnMA', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'CardCousins Homepage', profile: { data: { type: 'profile', attributes: { email: emailEl.value } } } }, relationships: { list: { data: { type: 'list', id: 'RCx9A5' } } } } })
      })
      .then(function (r) {
        if (r.ok || r.status === 202) {
          btn.textContent = 'Du bist drin!';
          emailEl.disabled = true;
          emailEl.value = '';
          emailEl.placeholder = 'Willkommen!';
          if (status) {
            status.textContent = nlForm.dataset.success;
            status.style.color = '#c9a84c';
          }
        } else {
          fallback(btn);
        }
      })
      .catch(function () { fallback(btn); });
    });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  $$('.cc-fade-up, .cc-kintsugi').forEach(function (el) { observer.observe(el); });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-product-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.currentScript ? document.currentScript.parentElement : document;
  var page = document.querySelector('.cc-page');
  if (!page) return;

  function $(sel, scope) { return (scope || page).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || page).querySelectorAll(sel)); }

  var nav = $('#cc-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    });
  }

  var hamburger = $('#cc-hamburger'),
      menuDrawer = $('#cc-menu-drawer'),
      menuOverlay = $('#cc-menu-overlay');
  function toggleMenu() {
    if (!menuDrawer) return;
    hamburger.classList.toggle('open');
    menuDrawer.classList.toggle('open');
    menuOverlay.classList.toggle('open');
    document.body.style.overflow = menuDrawer.classList.contains('open') ? 'hidden' : '';
  }
  if (hamburger) hamburger.addEventListener('click', toggleMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', toggleMenu);
  $$('[data-cc-menu-close]').forEach(function (btn) { btn.addEventListener('click', toggleMenu); });
  if (menuDrawer) {
    var menuTouchX = null;
    menuDrawer.addEventListener('touchstart', function (e) { menuTouchX = e.touches[0].clientX; }, { passive: true });
    menuDrawer.addEventListener('touchend', function (e) {
      if (menuTouchX !== null && menuTouchX - e.changedTouches[0].clientX > 60 && menuDrawer.classList.contains('open')) toggleMenu();
      menuTouchX = null;
    });
  }
  if (menuDrawer) menuDrawer.addEventListener('click', function (e) {
    if (e.target.closest('a') && menuDrawer.classList.contains('open')) toggleMenu();
  });

  var cartToggle = $('#cc-cart-toggle'),
      cartDrawer = $('#cc-cart-drawer'),
      cartOverlay = $('#cc-cart-overlay'),
      cartClose = $('#cc-cart-close'),
      cartItems = $('#cc-cart-items'),
      cartEmpty = $('#cc-cart-empty'),
      cartFooter = $('#cc-cart-footer'),
      cartTotal = $('#cc-cart-total'),
      cartCount = $('#cc-cart-count');

  function fmtMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (cartCount) {
        cartCount.textContent = cart.item_count;
        cartCount.classList.toggle('show', cart.item_count > 0);
      }
      if (!cartItems) return;
      var confirmBanner = $('#cc-cart-confirm');
      if (cart.items.length === 0) {
        cartEmpty.style.display = '';
        cartItems.innerHTML = '';
        cartFooter.style.display = 'none';
        if (confirmBanner) confirmBanner.classList.remove('show');
        return;
      }
      if (confirmBanner) confirmBanner.classList.add('show');
      cartEmpty.style.display = 'none';
      cartFooter.style.display = '';
      cartTotal.textContent = fmtMoney(cart.total_price);
      var ccCompare = {};
      try { ccCompare = JSON.parse(document.getElementById('cc-compare-data').textContent); } catch (e) {}
      var totalSavings = 0;
      var html = cart.items.map(function (item) {
        var compareLine = 0;
        if (item.original_line_price > item.final_line_price) {
          compareLine = item.original_line_price;
        } else if (ccCompare[item.variant_id]) {
          compareLine = ccCompare[item.variant_id] * item.quantity;
        }
        var priceHtml = '';
        var itemSavingsHtml = '';
        if (compareLine > item.final_line_price) {
          totalSavings += compareLine - item.final_line_price;
          priceHtml = '<s class="cc-cart-item-compare">' + fmtMoney(compareLine) + '</s> ';
          itemSavingsHtml = '<div class="cc-cart-item-savings">Du sparst ' + fmtMoney(compareLine - item.final_line_price) + '</div>';
        }
        priceHtml += '<span class="cc-cart-item-price">' + fmtMoney(item.final_line_price) + '</span>';
        return '<div class="cc-cart-item">' +
          '<div class="cc-cart-item-img"><img src="' + esc(item.image) + '" alt=""></div>' +
          '<div class="cc-cart-item-info">' +
            '<div class="cc-cart-item-title">' + esc(item.product_title) + '</div>' +
            '<div class="cc-cart-item-variant">' + esc(item.variant_title || '') + '</div>' +
            '<div class="cc-cart-item-row">' +
              '<span class="cc-cart-item-qty">' +
                '<button class="cc-cart-qty-btn" data-key="' + esc(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Menge verringern">&minus;</button>' +
                '<span class="cc-cart-qty-value">' + item.quantity + '</span>' +
                '<button class="cc-cart-qty-btn" data-key="' + esc(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Menge erh&ouml;hen">+</button>' +
              '</span>' +
              '<span>' + priceHtml + '</span>' +
            '</div>' +
            itemSavingsHtml +
            '<button class="cc-cart-item-remove" data-key="' + esc(item.key) + '">Entfernen</button>' +
          '</div>' +
        '</div>';
      }).join('');
      var savingsRow = $('#cc-cart-savings-row');
      if (savingsRow) {
        savingsRow.style.display = totalSavings > 0 ? '' : 'none';
        if (totalSavings > 0) $('#cc-cart-savings').textContent = '-' + fmtMoney(totalSavings);
      }
      if (totalSavings > 0) {
        cartTotal.innerHTML = '<s class="cc-cart-total-compare">' + fmtMoney(cart.total_price + totalSavings) + '</s> ' + fmtMoney(cart.total_price);
      }
      cartItems.innerHTML = html;
      $$('.cc-cart-qty-btn', cartItems).forEach(function (btn) {
        btn.addEventListener('click', function () {
          btn.disabled = true;
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: btn.dataset.key, quantity: parseInt(btn.dataset.qty, 10) })
          }).then(refreshCart);
        });
      });
      $$('.cc-cart-item-remove', cartItems).forEach(function (btn) {
        btn.addEventListener('click', function () {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
          }).then(refreshCart);
        });
      });
    }).catch(function () {});
  }
  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  refreshCart();

  var galleryMain = $('#cc-gallery-main');
  var mainItems = $$('#cc-gallery-main > *');
  var thumbsContainer = $('#cc-gallery-thumbs');
  var galleryPrev = $('#cc-gallery-prev'), galleryNext = $('#cc-gallery-next');
  var progressFill = $('#cc-gallery-progress-fill');
  var mobileGallery = window.matchMedia('(max-width: 749px)');
  var activeIdx = null, galleryScrollTimer = null;

  function visibleItems() {
    return mainItems.filter(function (item) { return !item.classList.contains('is-hidden'); });
  }
  function visiblePos() {
    var items = visibleItems();
    for (var i = 0; i < items.length; i++) if (items[i].dataset.index === activeIdx) return i;
    return 0;
  }
  // smooth: animate the mobile track; fromScroll: the user already swiped there, so leave the track alone
  function showSlide(idx, smooth, fromScroll) {
    idx = String(idx);
    activeIdx = idx;
    mainItems.forEach(function (item) {
      item.classList.remove('active');
      if (item.tagName === 'VIDEO') item.pause();
    });
    $$('.cc-gallery-thumb').forEach(function (t) { t.classList.remove('active'); });
    var target = $('#cc-gallery-main > [data-index="' + idx + '"]');
    if (target) {
      target.classList.add('active');
      if (target.tagName === 'VIDEO') target.play();
    }
    var thumb = $('.cc-gallery-thumb[data-index="' + idx + '"]');
    if (thumb) thumb.classList.add('active');

    var count = visibleItems().length, pos = visiblePos();
    if (progressFill) progressFill.style.width = (count ? (pos + 1) / count * 100 : 0) + '%';
    if (galleryPrev) galleryPrev.hidden = pos === 0;
    if (galleryNext) galleryNext.hidden = count < 2;
    if (!mobileGallery.matches) return;
    if (target && !fromScroll) galleryMain.scrollTo({ left: target.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    if (thumb && thumbsContainer) {
      var stripRect = thumbsContainer.getBoundingClientRect(), thumbRect = thumb.getBoundingClientRect();
      thumbsContainer.scrollTo({ left: thumbsContainer.scrollLeft + thumbRect.left - stripRect.left - (stripRect.width - thumbRect.width) / 2, behavior: 'smooth' });
    }
  }
  function stepSlide(dir) {
    var items = visibleItems();
    if (!items.length) return;
    var next = (visiblePos() + dir + items.length) % items.length;
    showSlide(items[next].dataset.index, true);
  }
  var activeThumb = $('.cc-gallery-thumb.active');
  if (mainItems.length > 0) showSlide(activeThumb ? activeThumb.dataset.index : 0);

  if (galleryMain) {
    galleryMain.addEventListener('scroll', function () {
      if (!mobileGallery.matches) return;
      clearTimeout(galleryScrollTimer);
      galleryScrollTimer = setTimeout(function () {
        var items = visibleItems();
        var item = items[Math.round(galleryMain.scrollLeft / galleryMain.clientWidth)];
        if (item && item.dataset.index !== activeIdx) showSlide(item.dataset.index, false, true);
      }, 80);
    });
  }
  if (galleryPrev) galleryPrev.addEventListener('click', function () { stepSlide(-1); });
  if (galleryNext) galleryNext.addEventListener('click', function () { stepSlide(1); });
  if (mobileGallery.addEventListener) {
    mobileGallery.addEventListener('change', function () { if (activeIdx !== null) showSlide(activeIdx); });
  }

  // Returns true when the variant has own tagged media (gallery filtered), false when all media stay visible
  function filterGallery(tag) {
    var thumbs = $$('.cc-gallery-thumb');
    var hasOwn = !!tag && thumbs.some(function (t) { return t.dataset.galleryTag === tag; });
    var first = null;
    thumbs.forEach(function (t) {
      var hide = hasOwn && !!t.dataset.galleryTag && t.dataset.galleryTag !== tag;
      t.classList.toggle('is-hidden', hide);
      var mainItem = $('#cc-gallery-main > [data-index="' + t.dataset.index + '"]');
      if (mainItem) mainItem.classList.toggle('is-hidden', hide);
      if (!hide && first === null) first = t.dataset.index;
    });
    if (hasOwn && first !== null) showSlide(first);
    return hasOwn;
  }
  if (thumbsContainer) {
    thumbsContainer.addEventListener('click', function (e) {
      var thumb = e.target.closest('.cc-gallery-thumb');
      if (thumb) showSlide(thumb.dataset.index, true);
    });
  }

  var variantBtns = $$('.cc-variant-btn');
  var variantNameEl = $('#cc-variant-name');
  var variantIdInput = $('#cc-variant-id');
  var atcBtn = $('#cc-atc-btn');
  var atcPriceEl = $('#cc-atc-price');
  var priceEl = $('#cc-price');
  var qtyInput = $('#cc-qty-input');

  function selectVariant(btn) {
    if (!btn || btn.disabled) return;
    variantBtns.forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    if (variantNameEl) variantNameEl.textContent = btn.dataset.name;
    if (variantIdInput) variantIdInput.value = btn.dataset.variantId;
    if (priceEl) priceEl.textContent = btn.dataset.price;
    if (atcPriceEl) atcPriceEl.textContent = btn.dataset.price;
    if (!filterGallery(btn.dataset.galleryTag) && btn.dataset.mediaId) {
      var mediaThumb = $('.cc-gallery-thumb[data-media-id="' + btn.dataset.mediaId + '"]');
      if (mediaThumb) showSlide(mediaThumb.dataset.index);
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', btn.dataset.variantId);
    window.history.replaceState({}, '', url.toString());
  }
  variantBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { selectVariant(btn); });
  });

  var qtyMinus = $('#cc-qty-minus'), qtyPlus = $('#cc-qty-plus');
  if (qtyMinus) qtyMinus.addEventListener('click', function () {
    var v = parseInt(qtyInput.value) || 1;
    if (v > 1) qtyInput.value = v - 1;
  });
  if (qtyPlus) qtyPlus.addEventListener('click', function () {
    var v = parseInt(qtyInput.value) || 1;
    if (v < 10) qtyInput.value = v + 1;
  });
  if (qtyInput) qtyInput.addEventListener('change', function () {
    var v = parseInt(qtyInput.value) || 1;
    qtyInput.value = Math.max(1, Math.min(10, v));
  });

  var productForm = $('#cc-product-form');
  var atcStatus = $('#cc-atc-status');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!atcBtn || atcBtn.disabled) return;
      var formData = new FormData(productForm);
      formData.set('quantity', qtyInput ? qtyInput.value : 1);
      var originalHtml = atcBtn.innerHTML;
      atcBtn.disabled = true;
      atcBtn.innerHTML = 'Wird hinzugefügt...';
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Fehler'); });
        return res.json();
      })
      .then(function () {
        atcBtn.innerHTML = 'Hinzugefügt ✓';
        if (atcStatus) {
          atcStatus.textContent = (qtyInput ? qtyInput.value : 1) + '× hinzugefügt';
          atcStatus.style.color = '#c9a84c';
        }
        return refreshCart();
      })
      .then(function () {
        setTimeout(function () {
          atcBtn.innerHTML = originalHtml;
          atcBtn.disabled = false;
          if (atcStatus) atcStatus.textContent = '';
        }, 2500);
      })
      .catch(function (err) {
        atcBtn.innerHTML = originalHtml;
        atcBtn.disabled = false;
        if (atcStatus) {
          atcStatus.textContent = err.message || 'Fehler - bitte erneut versuchen';
          atcStatus.style.color = '#ff8900';
        }
      });
    });
  }

  document.querySelectorAll('[data-cc-addon]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var originalHtml = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Wird hinzugefügt...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-cc-addon')), quantity: 1 }] })
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Fehler'); });
        btn.innerHTML = 'Hinzugefügt ✓';
        openCart();
        setTimeout(function () { btn.innerHTML = originalHtml; btn.disabled = false; }, 2500);
      })
      .catch(function () {
        btn.innerHTML = 'Bitte erneut versuchen';
        setTimeout(function () { btn.innerHTML = originalHtml; btn.disabled = false; }, 2500);
      });
    });
  });

  /* Judge.me carousel renders as its own apps section at page bottom (app blocks are rejected inside this section's schema); relocate it under the reviews heading */
  var reviewsSlot = $('#cc-reviews-slot');
  var jdgmSection = document.querySelector('.shopify-section[id*="judgeme_cards_carousel"]');
  if (reviewsSlot && jdgmSection) {
    reviewsSlot.appendChild(jdgmSection);
    var pressTpl = $('#cc-press-card-tpl');
    if (pressTpl) {
      var injectPress = function () {
        if (jdgmSection.querySelector('.cc-press-jdgm')) return;
        var items = jdgmSection.querySelectorAll('.jdgm-carousel-item:not([class*="clone"])');
        if (items.length < 2) return;
        items[1].after(pressTpl.content.firstElementChild.cloneNode(true));
      };
      injectPress();
      new MutationObserver(injectPress).observe(jdgmSection, { childList: true, subtree: true });
    }
    if (window.matchMedia('(max-width: 700px)').matches) {
      /* Judge.me's slider JS swallows touch events; capture-stop them so the native overflow scroll gets the swipe */
      ['touchstart', 'touchmove', 'touchend'].forEach(function (t) {
        reviewsSlot.addEventListener(t, function (e) { e.stopPropagation(); }, { capture: true, passive: true });
      });
    }
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  $$('.cc-fade-up, .cc-kintsugi').forEach(function (el) { observer.observe(el); });

})();

  } catch(e) { console.error(e); }
})();
})();
